import { StreamType } from '../../stream/enums/stream-type';
const formatHdcpVersion = (hdcpVersion) => {
    if (!hdcpVersion) {
        return 'unknown';
    }
    if (hdcpVersion === 'unprotected') {
        return 'none';
    }
    return hdcpVersion;
};
const formatDrmStreamType = (streamType) => {
    switch (streamType) {
        case StreamType.DASH_WIDEVINE:
            return 'widevine';
        case StreamType.DASH_PLAYREADY:
            return 'playready';
        case StreamType.HLS7_FAIRPLAY:
            return 'fairplay';
        default:
            return null;
    }
};
export const formatCapabilities = (capabilities) => {
    if (!capabilities) {
        return [];
    }
    let hdcp;
    if (capabilities.hdcpLevel) {
        hdcp = `hdcp/${formatHdcpVersion(capabilities.hdcpLevel.connectedVersion)};${formatHdcpVersion(capabilities.hdcpLevel.maxSupportedVersion)}`;
    }
    return [
        ...(capabilities.audioCodecs?.map((codec) => `audio/${codec}`) ?? []),
        ...(capabilities.videoCodecs?.map((codec) => `video/${codec}`) ?? []),
        ...(capabilities.subtitlesCodecs?.map((codec) => `text/${codec}`) ?? []),
        ...capabilities.streamTypeInformation.map((drm) => {
            const drmName = formatDrmStreamType(drm.type);
            if (!drmName) {
                return null;
            }
            return (`drm/${drmName};${drm.maxSecurityLevel ?? 'unknown'};${drm.version ?? 'unknown'}`);
        }).filter(Boolean),
        ...(hdcp ? [hdcp] : []),
    ];
};
